module.exports = "//img1.rrcimg.com/_next/static/src/assets/wechat_2bhPf.jpg";